import { render, staticRenderFns } from "./BathSettingScreen.vue?vue&type=template&id=3217f6fa&scoped=true&"
import script from "./BathSettingScreen.vue?vue&type=script&lang=js&"
export * from "./BathSettingScreen.vue?vue&type=script&lang=js&"
import style0 from "./BathSettingScreen.vue?vue&type=style&index=0&id=3217f6fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217f6fa",
  null
  
)

component.options.__file = "BathSettingScreen.vue"
export default component.exports